// „Настани" от Маркиране — чиста логика без React (тестове:
// seatReservationGroups.test.ts): списъкът по часове и статусът спрямо
// „сега". Изборът къде да седнат гостите — seatOptions.ts.

import type { SeatableReservation } from "../../../../../api/reservations";
import { MINUTE_MS } from "../../../../reservations/logic/dayTime";
import { matchesSearch } from "../../../../reservations/logic/reservationList";
import { reservationStartMs } from "../../../../reservations/logic/tableStatus";

// „Скоро" (зелено) съвпада с прозореца на „Настани" (SEAT_EARLY_MINUTES).
const SOON_MINUTES = 30;

export interface SeatHourGroup {
  /** Началото на часа (ms) — „18:00". */
  hourMs: number;
  reservations: SeatableReservation[];
  guests: number;
}

const hourStartOf = (moment: number) => {
  const date = new Date(moment);
  date.setMinutes(0, 0, 0);
  return date.getTime();
};

/** Намерените след търсенето, по начало, разделени по час („18:00 · 2 · 6 гости"). */
export const groupByHour = (reservations: SeatableReservation[], query: string): SeatHourGroup[] => {
  const groups: SeatHourGroup[] = [];
  const sorted = reservations
    .filter((reservation) => matchesSearch(reservation, query))
    .sort((left, right) => reservationStartMs(left) - reservationStartMs(right) || left.id - right.id);
  for (const reservation of sorted) {
    const hourMs = hourStartOf(reservationStartMs(reservation));
    const last = groups[groups.length - 1];
    if (last && last.hourMs === hourMs) {
      last.reservations.push(reservation);
      last.guests += reservation.guests;
    } else {
      groups.push({ hourMs, reservations: [reservation], guests: reservation.guests });
    }
  }
  return groups;
};

/** Спрямо „сега": закъснява N мин, след N мин, или точно в минутата на часа. */
export type SeatTiming =
  | { kind: "late"; minutes: number }
  | { kind: "soon"; minutes: number }
  | { kind: "now" };

export const seatTimingOf = (reservation: SeatableReservation, nowMs: number): SeatTiming => {
  const diffMs = reservationStartMs(reservation) - nowMs;
  if (diffMs > 0) return { kind: "soon", minutes: Math.ceil(diffMs / MINUTE_MS) };
  const late = Math.floor(-diffMs / MINUTE_MS);
  return late >= 1 ? { kind: "late", minutes: late } : { kind: "now" };
};

/** Цветът на статуса: закъснява — червено, до 30 мин — зелено, по-късно — сиво. */
export const timingToneClass = (timing: SeatTiming) =>
  timing.kind === "late"
    ? "text-pos-danger-ink"
    : timing.kind === "now" || timing.minutes <= SOON_MINUTES
      ? "text-pos-served"
      : "text-pos-soft2";
